import { render } from "./AdminGala.vue?vue&type=template&id=262865c6&scoped=true"
import script from "./AdminGala.vue?vue&type=script&lang=js"
export * from "./AdminGala.vue?vue&type=script&lang=js"

import "./AdminGala.vue?vue&type=style&index=0&id=262865c6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-262865c6"]])

export default __exports__